(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ka-product-labels"] && !Shopify.designMode) return;
  try {
    (function () {
    // Læg labels oven på produktbilledet. Ankeret er billedets viewport
    // (slideshow-container), så labels ikke lander oven på miniaturerne.
    function anchorFor(gallery) {
      return (
        gallery.querySelector('slideshow-container') ||
        gallery.querySelector('.product-media-container') ||
        gallery
      );
    }

    function place() {
      document.querySelectorAll('[data-ka-labels-source]').forEach(function (source) {
        var section = source.closest('.shopify-section') || document;
        var gallery = section.querySelector('media-gallery');
        if (!gallery) return;

        var labels = source.querySelector('.ka-badges');
        if (!labels) return;

        var sig = source.dataset.kaLabelsSig || '';
        var placed = gallery.querySelector('.ka-badges--placed[data-ka-labels-sig="' + sig + '"]');
        if (placed) return;

        // Ryd kun op efter denne blok (signaturen starter med blokkens id),
        // så flere label-blokke på samme side ikke fjerner hinandens labels.
        var owner = sig.split(':')[0] + ':';
        gallery.querySelectorAll('.ka-badges--placed').forEach(function (stale) {
          if ((stale.getAttribute('data-ka-labels-sig') || '').indexOf(owner) === 0) stale.remove();
        });

        var corner = source.dataset.kaLabelsCorner || 'top-left';
        var offset = source.dataset.kaLabelsOffset || '10';

        var clone = labels.cloneNode(true);
        clone.classList.add('ka-badges--placed', 'ka-badges--' + corner);
        clone.setAttribute('data-ka-labels-sig', sig);
        clone.style.setProperty('--ka-placed-offset', offset + 'px');

        var anchor = anchorFor(gallery);
        if (getComputedStyle(anchor).position === 'static') {
          anchor.style.position = 'relative';
        }
        anchor.appendChild(clone);
      });
    }

    // Mestershop: "Tryk"-labels åbner Podifai-popuppen ved klik.
    function bindPodifai() {
      var podifaiBtn = document.getElementById('podifai-customise-btn');
      if (!podifaiBtn) return false;
      document.querySelectorAll('[data-ka-labels-podifai] .ka-badge[class*="tryk"]').forEach(function (badge) {
        if (badge.dataset.kaPodifaiBound) return;
        badge.dataset.kaPodifaiBound = 'true';
        badge.classList.add('is-podifai-trigger');
        badge.setAttribute('role', 'button');
        badge.setAttribute('tabindex', '0');
        badge.addEventListener('click', function () { podifaiBtn.click(); });
        badge.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            podifaiBtn.click();
          }
        });
      });
      return true;
    }

    function watchPodifai() {
      if (!document.querySelector('[data-ka-labels-podifai]')) return;
      if (bindPodifai()) return;
      var tries = 0;
      var iv = setInterval(function () {
        if (bindPodifai() || ++tries > 40) clearInterval(iv);
      }, 250);
    }

    function watch() {
      place();
      watchPodifai();
      document.querySelectorAll('[data-ka-labels-source]').forEach(function (source) {
        var section = source.closest('.shopify-section');
        if (!section || section.dataset.kaLabelsObserved) return;
        section.dataset.kaLabelsObserved = 'true';
        // Hvis Horizon genopbygger billedgalleriet (fx ved variantskift), placeres labels igen.
        new MutationObserver(function () {
          place();
        }).observe(section, { childList: true, subtree: true });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', watch);
    } else {
      watch();
    }

    document.addEventListener('shopify:section:load', function () {
      setTimeout(watch, 0);
    });
    document.addEventListener('shopify:block:select', function () {
      setTimeout(place, 0);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ka-quantity-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ka-quantity-offer')) {
    const kaQoState = (window.__kaQuantityOffer = window.__kaQuantityOffer || {});

    class KaQuantityOffer extends HTMLElement {
      connectedCallback() {
        this.addEventListener('change', (event) => {
          if (event.target.matches('.ka-qo__input')) {
            kaQoState[this.dataset.productId] = event.target.value;
            this.apply();
          }
        });
        this.apply();
      }

      get form() {
        const sectionId = this.dataset.sectionId;
        return (
          document.getElementById('BuyButtons-ProductForm-' + sectionId) ||
          this.closest('.shopify-section')?.querySelector('form[data-type="add-to-cart-form"]')
        );
      }

      get quantity() {
        const saved = kaQoState[this.dataset.productId];
        if (saved) {
          const savedInput = this.querySelector('.ka-qo__input[value="' + saved + '"]');
          if (savedInput) savedInput.checked = true;
        }
        const checked = this.querySelector('.ka-qo__input:checked');
        return checked ? checked.value : this.dataset.defaultQty;
      }

      apply() {
        const form = this.form;
        if (!form) return;
        let input = form.querySelector('input[name="quantity"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'quantity';
          form.appendChild(input);
        }
        input.value = this.quantity;
      }
    }

    customElements.define('ka-quantity-offer', KaQuantityOffer);

    // Re-apply right before any add-to-cart submit (covers variant re-renders).
    document.addEventListener(
      'submit',
      (event) => {
        document.querySelectorAll('ka-quantity-offer').forEach((offer) => {
          if (offer.form === event.target) offer.apply();
        });
      },
      true
    );

    // Re-apply after Horizon re-renders the section on variant change.
    document.addEventListener('variant:update', () => {
      requestAnimationFrame(() => {
        document.querySelectorAll('ka-quantity-offer').forEach((offer) => offer.apply());
      });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ka-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    function cardOf(el) {
      return el.closest('.product-card, .product-grid__card, .card, li') || el.parentElement;
    }
    function imgOf(card) {
      if (!card) return null;
      return card.querySelector('.product-media img, .card-gallery img, .product-card__image img, img');
    }
    document.addEventListener('mouseover', function (e) {
      var dot = e.target.closest('.ka-cs__dot[data-ka-media]');
      if (!dot) return;
      var media = dot.getAttribute('data-ka-media');
      if (!media) return;
      var img = imgOf(cardOf(dot));
      if (!img) return;
      if (!img.dataset.kaOrig) {
        img.dataset.kaOrig = img.currentSrc || img.src || '';
        img.dataset.kaOrigSet = img.getAttribute('srcset') || '';
      }
      img.setAttribute('srcset', '');
      img.src = media;
    });
    document.addEventListener('mouseout', function (e) {
      var dot = e.target.closest('.ka-cs__dot[data-ka-media]');
      if (!dot) return;
      var img = imgOf(cardOf(dot));
      if (!img || !img.dataset.kaOrig) return;
      img.src = img.dataset.kaOrig;
      if (img.dataset.kaOrigSet) img.setAttribute('srcset', img.dataset.kaOrigSet);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
